module.exports = __webpack_public_path__ + "img/dk_no.846ce3a2.png";